module.exports = __webpack_public_path__ + "img/jackpot-history.f48d29de.svg";